import React from "react";
import PropTypes from "prop-types";
import classcat from "classcat";
import { Grid, Typography } from "@material-ui/core";
import alternateCountryTranslations from "../../../../../infrastructure/translate/alternateCountyTranslations";
import useStyles from "./styles";

export default function MealCustomText({ country }) {
  const { container, textStyle, greenPoint, itemTextStyle, limitText } =
    useStyles();
  return (
    <>
      <Typography variant="body2" className={textStyle}>
        {alternateCountryTranslations(
          country,
          "benefit-meal-tooltip-description"
        )}
      </Typography>
      <Typography variant="body2" className={classcat([textStyle, limitText])}>
        {alternateCountryTranslations(country, "benefit-meal-tooltip-limits")}
      </Typography>
      <>
        <Grid container className={container} alignItems="center">
          <div className={greenPoint} />
          <Typography variant="body2" className={itemTextStyle}>
            {alternateCountryTranslations(
              country,
              "benefit-meal-tooltip-restaurants"
            )}
          </Typography>
        </Grid>
        <Grid container className={container} alignItems="center">
          <div className={greenPoint} />
          <Typography variant="body2" className={itemTextStyle}>
            {alternateCountryTranslations(
              country,
              "benefit-meal-tooltip-food-delivery"
            )}
          </Typography>
        </Grid>
        <Grid container className={container} alignItems="center">
          <div className={greenPoint} />
          <Typography variant="body2" className={itemTextStyle}>
            {alternateCountryTranslations(
              country,
              "benefit-meal-tooltip-supermarkets"
            )}
          </Typography>
        </Grid>
      </>
    </>
  );
}

MealCustomText.defaultProps = {
  country: "ES",
};

MealCustomText.propTypes = {
  country: PropTypes.string,
};
